<template>
  <shift-details :shift-id="id" />
</template>

<script setup lang="ts">
import ShiftDetails from '../ShiftDetails.vue';

defineProps<{
  id: string | number;
}>();
</script>
